import { render, staticRenderFns } from "./GridBox.vue?vue&type=template&id=422f227a"
import script from "./GridBox.vue?vue&type=script&lang=js"
export * from "./GridBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports